module.exports = __webpack_public_path__ + "img/gear.d0e4be1b.png";